import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PrimeurCampaign from '../index';
import styled from 'styled-components';
import PreparationScatterGraph from '../components/PreparationScatterGraph';
import PreparationBarGraph from '../components/PreparationBarGraph';
import { getPrimeurPrepa } from '../../../actions/primeur';
import PrepaparationLineGraph from '../components/PreparationLineGraph';
import Spinner from '../../../components/Spinner';

const PreparationContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 80px;
  > div:not(last-child) {
    margin-bottom: 20px;
  }
`;

const Preparation = () => {
  const [loading, setLoading] = useState(true);

  const data = useSelector((state) => state.primeur.prepa);
  const client_wines = useSelector((state) => state.primeur.client_wines) || [];
  const rival_wines = useSelector((state) => state.primeur.rival_wines) || [];
  const dispatch = useDispatch();

  const dispatchGetPrimeurPrepa = useCallback(async () => {
    await dispatch(getPrimeurPrepa());
  }, [dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      await dispatchGetPrimeurPrepa();
      setLoading(false);
    };
    fetchData();
  }, [dispatchGetPrimeurPrepa]);

  const dataScatter = data?.price_vs_score || [];
  const dataBarChart = data?.primeur_vs_web || [];
  const dataLineChart = data?.all_notes || [];

  return (
    <PrimeurCampaign>
      <PreparationContainer>
        <PreparationScatterGraph
          data={dataScatter}
          client_wines={client_wines}
          rival_wines={rival_wines}
        />
        <PreparationBarGraph data={dataBarChart} client_wines={client_wines} />
        <PrepaparationLineGraph data={dataLineChart} />
      </PreparationContainer>

      <Spinner loading={loading} />
    </PrimeurCampaign>
  );
};

export default Preparation;
